module.exports = __webpack_public_path__ + "img/app.c1107da5.svg";